<template>
  <v-row>
    <v-col cols="12" class="pt-0">
      <v-progress-linear
        :style="{
          visibility: isFetching ? 'visible' : 'hidden'
        }"
        class="mb-3"
        indeterminate
        color="primary"
      />

      <v-row
        :class="`d-flex justify-space-between mb-6 px-3`"
        color="grey lighten-2"
        align="center"
      >
        <span>
          <v-btn
            rounded
            outlined
            icon
            color="primary"
            class="mr-1"
            @click="onPrevious()"
          >
            <v-icon>navigate_before</v-icon>
          </v-btn>
          <v-btn
            rounded
            outlined
            icon
            color="primary"
            class="mr-3"
            @click="onNext()"
          >
            <v-icon>navigate_next</v-icon>
          </v-btn>

          <v-btn
            rounded
            outlined
            color="primary"
            class="mr-3"
            @click="onToday()"
          >
            Today
          </v-btn>

          <v-menu
            ref="dateMenu"
            v-model="dateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                outlined
                small
                color="primary"
                v-on="on"
              >
                <v-icon small>calendar_today</v-icon>
              </v-btn>

            </template>

            <v-date-picker
              no-title
              scrollable
              @change="onGotoDate"
            />
          </v-menu>
        </span>

        <span class="display-1">
          {{ title }}
        </span>

        <span>
<!--          <v-btn-->
<!--            rounded-->
<!--            outlined-->
<!--            color="primary"-->
<!--            class="mr-1"-->
<!--            @click="onChangeView('month')"-->
<!--          >-->
<!--            Month-->
<!--          </v-btn>-->
          <v-btn
            rounded
            outlined
            color="primary"
            class="mr-1"
            @click="onChangeView('week')"
          >
            Week
          </v-btn>
          <v-btn
            rounded
            outlined
            color="primary"
            @click="onChangeView('day')"
          >
            Day
          </v-btn>
        </span>
      </v-row>

      <full-calendar
        class="schedule-calendar"
        ref="fullCalendar"
        :options="calendarOptions()"
      >
        <template v-slot:eventContent='arg'>
          <b>{{ getTimeText(arg) }}</b>
          •
          <i>{{ arg.event.title }}</i>
        </template>
      </full-calendar>

      <shift-create-update-dialog
        @shift-change="fetchEvents()"
      />
    </v-col>
  </v-row>
</template>
<style>
  @import '~@fullcalendar/timeline/main.css';
  @import '~@fullcalendar/resource-timeline/main.css';
  @import '~@fullcalendar/daygrid/main.css';

  /**
  Some bug in 5.0.0-beta.4 is not hiding the warning message even with a valid key
   */
  .fc-license-message {
    display: none;
  }

  .schedule-calendar .fc-event {
    margin: 3px;
    background-color: transparent;
    border-style: dashed;
    border-width: 1px;
    border-radius: 2px;
  }

  .schedule-calendar .fc-event.published {
    background-color: #3788d8;
    border: none;
  }
</style>
<script>
import { convertTimestampToDate } from "../../services/util.service"
import { mapActions, mapGetters } from 'vuex'
import FullCalendar from '\@fullcalendar/vue'
import ResourceTimelinePlugin from "\@fullcalendar/resource-timeline"
import InteractionPlugin from "\@fullcalendar/interaction"
import DayGridPlugin from "\@fullcalendar/daygrid"
import MomentPlugin from "\@fullcalendar/moment"
import moment from 'moment'
import { isEmpty } from 'lodash'
import ShiftCreateUpdateDialog from "../Shift/ShiftCreateUpdateDialog"

import OPTION_REFINERS  from '\@fullcalendar/premium-common'
OPTION_REFINERS.schedulerLicenseKey = process.env.VUE_APP_FULL_CALENDAR_LICENSE_KEY

export default {
  components: {
    ShiftCreateUpdateDialog,
    FullCalendar
  },
  computed: {
    ...mapGetters([ 'getScheduleGroups', 'getScheduleGroupLabel', 'getScheduledProducts' ]),
  },
  data() {
    return {
      title: '',
      dateMenu: false,
      isFetching: false
    }
  },
  mounted() {
    this.initScheduleGroups()
    this.initProducts()
    this.updateTitle()
  },
  methods: {
    ...mapActions([ 'initScheduleGroups', 'initProducts', 'openShiftDialog' ]),
    getTimeText(arg) {
      const { event } = arg || {}
      const { start, end } = event
      const startTimeText = moment(start)
        .format('h:mma')
        .slice(0, -1) // remove the "m" from am/pm
      const endTimeText = moment(end)
        .format('h:mma')
        .slice(0, -1) // remove the "m" from am/pm

      return `${startTimeText} - ${endTimeText}`
    },
    fullCalendarAPI() {
      return this.$refs.fullCalendar
        ? this.$refs.fullCalendar.getApi()
        : {}
    },
    updateTitle() {
      this.title = this.fullCalendarAPI().view
        ? this.fullCalendarAPI().view.title
        : ''

      this.fetchEvents()
    },
    getEventSources() {
      return [

      ]
    },
    onGotoDate(date) {
      this.dateMenu = false
      this.fullCalendarAPI().gotoDate(date)
      this.updateTitle()
    },
    onNext() {
      this.fullCalendarAPI().next()
      this.updateTitle()
    },
    onPrevious() {
      this.fullCalendarAPI().prev()
      this.updateTitle()
    },
    onToday() {
      this.fullCalendarAPI().today()
      this.updateTitle()
    },
    onChangeView(view) {
      this.fullCalendarAPI().changeView(view)
      this.updateTitle()
    },
    fetchEvents(){
      const { currentStart, type } = this.fullCalendarAPI().view || {}



      const startStr = moment(currentStart).format('YYYY-MM-DD')

      const onSuccess = (response) => {
        const { data: events = [] } = response

        const mappedEvents = events.map(event => {
          const resourceId = event.meta.id

          const startDate = convertTimestampToDate(event.startAt)
          const start = startDate.toISOString()

          const endDate = convertTimestampToDate(event.endAt)
          const end = endDate.toISOString()

          const diff = moment(endDate).diff(moment(startDate))

          const duration = moment.duration(diff).asMilliseconds()

          const hours = moment.utc(duration).format('H[h]')
          const minutes = moment.utc(duration).format('m') === '0'
            ? ''
            : ` ${moment.utc(duration).format('m[min]')}`

          const title = `${hours}${minutes}`

          return {
            id: event.id,
            className: event.isPublished ? 'published' : '',
            timeText: 'testlife',
            title,
            resourceId,
            start,
            end,
            extendedProps: { ...event }
          }
        })

        /**
         * !!! IMPORTANT !!!
         * Every time we hit "addEvent" it triggers a render of the calendar. Instead we use the
         * batchRendering function to ensure all our events are updated first before performing a render
         *
         * Without batchRendering the browser can crash and timeout on even medium powered machines
         **/
        this.fullCalendarAPI().batchRendering(() =>  {
          const allEvents = this.fullCalendarAPI().getEvents()
          // setting to true, because we only care about a map of IDs
          const eventsMap = allEvents.reduce((prev, curr) => ({ ...prev, [curr.id]: true}), {})
          mappedEvents.forEach(event => {

            const existingEvent = this.fullCalendarAPI().getEventById(event.id)

            // Only add new events
            // @todo Update existing events
            if (isEmpty(existingEvent)) {
              this.fullCalendarAPI().addEvent(event)
            } else {
              // In order to trigger changes to the CSS classes, its easier to just remove the event and re-add it
              existingEvent.remove()
              this.fullCalendarAPI().addEvent(event)

              // If the event exists, remove it from our map
              delete eventsMap[event.id]
            }
          })

          // Once we are done updating/adding all our events, we need to remove any that no longer exist
          // The map will contains the ones we did not find in the API response
          for (const eventId in eventsMap) {
            const event = this.fullCalendarAPI().getEventById(eventId)
            event.remove()
          }
        })
      }

      const onError = (response) => {
        console.log('shift error', response)
      }

      const payload = {
        params: {
          rangeStart: startStr,
          mode: type
        }
      }

      this.isFetching = true
      this.$api.get('/api/shift', payload)
        .then(onSuccess)
        .catch(onError)
        .finally(() => {
          this.isFetching = false
        })
    },
    debug(arg) {
      console.log(arg)
      return 'test'
    },
    resources() {
      const scheduledProducts = this.getScheduledProducts

      const mappedProducts = scheduledProducts.map(p => {
        return {
          id: p.id,
          group: this.getScheduleGroupLabel(p.scheduleGroup) || undefined,
          title: p.label
          //capacity: p.quantity
        }
      })

      return mappedProducts.sort((a, b) => {
        const groupA = a.group ? a.group.toUpperCase() : ''
        const groupB = b.group ? b.group.toUpperCase() : ''

        const titleA = a.title ? a.title.toUpperCase() : ''
        const titleB = b.title ? b.title.toUpperCase() : ''

        // First, sort by group
        if (groupA > groupB) return 1
        if (groupA < groupB) return -1

        // Sub-sort by title
        if (titleA > titleB) return 1
        if (titleA < titleB) return -1

        return 0
      })
    },
    calendarOptions() {
      /**
       * !!! IMPORTANT !!!
       *
       * You cannot use any form of "this" in this return. It causes infinitely loops inside
       * fullcalendar.
       *
       * You cannot even do "that = this".
       *
       * Only raw javascript can be used in callbacks
       */
      return {
        plugins: [ // plugins must be defined in the JS
          ResourceTimelinePlugin,
          InteractionPlugin, // needed for dateClick
          DayGridPlugin,
          MomentPlugin
        ],
        views: {
          // month: {
          //   type: 'dayGridMonth',
          //   dayHeaderFormat: {
          //     weekday: 'long',
          //   },
          // },
          week: {
            type: 'resourceTimeline',
            duration: { weeks: 1 },
            slotDuration: { days: 1 },
            slotLabelFormat: 'ddd D', // top level of text
          },
          day: {
            type: 'resourceTimelineDay',
            duration: { days: 1 },
            slotDuration: { minutes: 15 },
            slotLabelFormat: [
              { weekday: 'long' }, // lower level of text
              { hour: 'numeric', meridiem: 'short' } // top level of text
            ]
          },
        },
        weekends: true,
        headerToolbar: false,
        eventClick: this.handleEventClick,
        initialView: 'week',
        resources: this.resources(),
        resourceAreaColumns: [
          {
            headerContent: { html: 'Resource <span class="grey--text">(Group)</span>' },
            field: 'title'
          }
        ],
        resourceLabelContent: (data) => {
          const { resource, fieldValue } = data || {}
          const { extendedProps } = resource || {}
          const { group } = extendedProps || {}
          const groupSpan = document.createElement('span')
          groupSpan.innerText = group ? ` (${group})` : ''
          groupSpan.style.color = 'grey'

          const labelSpan = document.createElement('span')
          labelSpan.innerText = fieldValue

          const arrayOfDomNodes = [ labelSpan, groupSpan ]
          return { domNodes: arrayOfDomNodes }
        },
        resourceAreaWidth: '25%',
        aspectRatio: 1.5,
        dateClick: this.handleDateClick,
        schedulerLicenseKey: process.env.VUE_APP_FULL_CALENDAR_LICENSE_KEY
      }
    },
    toggleWeekends() {
      this.calendarWeekends = !this.calendarWeekends // update a property
    },
    handleEventClick(data) {
      const { event } = data
      const { extendedProps: shift } = event

      const payload = { shift }
      this.openShiftDialog(payload)
    },
    handleDateClick(data) {
      const { resource, date } = data || {}
      const { id } = resource || {}

      const payload = {
        resourceIds: [ id ],
        date,
        type: 'product'
      }
      this.openShiftDialog(payload)

      // if (confirm('Would you like to add an event to ' + arg.dateStr + ' ?')) {
      //   this.calendarEvents.push({ // add new event data
      //     title: 'New Event',
      //     start: arg.date,
      //     allDay: arg.allDay
      //   })
      // }
    }
  }
}
</script>
